import { BaseClass } from './BaseClass';
import { Brand } from './Brand';
import { Campaigns } from './Campaigns';
import { Configurations } from './Configurations';
import { BrandSections } from './BrandSections';
import { PrintSections } from './PrinSections';
import { Menu } from './Menu';
import { Customers } from './Customers';
import { DataRequests } from './DataRequests';
import { Keys } from './Keys';

export class Permissions {
  Onboarding: BaseClass;
  ExcelUpload: BaseClass;
  WebsiteMonitor: BaseClass;
  Services: BaseClass;
  UserManagement: BaseClass;
  Configurations: Configurations;
  Settings: BaseClass;
  Menu: Menu;
  Products: BaseClass;
  Categories: BaseClass;
  Brand: Brand;
  Orders: BaseClass;
  Campaigns: Campaigns;
  Rewards: BaseClass;
  Customers: Customers;
  BlockedUsers: BaseClass;
  AccountTypes: BaseClass;
  AccountConfigs: BaseClass;
  Keys: Keys;
  FCM: BaseClass;

  ImportData: BaseClass;
  PrintSections: PrintSections;
  BrandSections: BrandSections;
  ReceiptTypes: BaseClass;
  Reservations: BaseClass;
  Events: BaseClass;
  Payments: BaseClass;
  Transactions: BaseClass;
  Accounts: BaseClass;
  DataRequests: DataRequests;
  MenuSchedule: BaseClass;

  constructor(obj: typeof PERMISSIONS = PERMISSIONS) {
    this.Onboarding = new BaseClass(obj.Onboarding);
    this.ExcelUpload = new BaseClass(obj.ExcelUpload);
    this.WebsiteMonitor = new BaseClass(obj.WebsiteMonitor);
    this.Services = new BaseClass(obj.Services);
    this.UserManagement = new BaseClass(obj.UserManagement);
    this.Configurations = new Configurations(obj.Configurations);
    this.Settings = new BaseClass(obj.Settings);
    this.Menu = new Menu(obj.Menu);
    this.Products = new BaseClass(obj.Products);
    this.Categories = new BaseClass(obj.Categories);
    this.Brand = new Brand(obj.Brand);
    this.Orders = new BaseClass(obj.Orders);
    this.Campaigns = new Campaigns(obj.Campaigns);
    this.Rewards = new BaseClass(obj.Rewards);
    this.Customers = new Customers(obj.Customers);
    this.BlockedUsers = new BaseClass(obj.BlockedUsers);
    this.AccountTypes = new BaseClass(obj.AccountTypes);
    this.AccountConfigs = new BaseClass(obj.AccountConfigs);
    // Users saved before the Keys module only have Mapkeys, so carry it over as Keys.Map
    const legacyMapkeys = (obj as any).Mapkeys;
    this.Keys = new Keys(
      obj.Keys ??
        (legacyMapkeys
          ? { ...legacyMapkeys, Map: legacyMapkeys, Firebase: undefined }
          : undefined)
    );
    this.FCM = new BaseClass(obj.FCM);
    this.ImportData = new BaseClass(obj.ImportData);
    this.PrintSections = new PrintSections(obj.PrintSections);
    this.BrandSections = new BrandSections(obj.BrandSections);
    this.ReceiptTypes = new BaseClass(obj.ReceiptTypes);
    this.Reservations = new BaseClass(obj.Reservations);
    this.Events = new BaseClass(obj.Events);
    this.Payments = new BaseClass(obj.Payments);
    this.Transactions = new BaseClass(obj.Transactions);
    this.Accounts = new BaseClass(obj.Accounts);
    this.DataRequests = new DataRequests(obj.DataRequests);
    this.MenuSchedule = new DataRequests(obj.MenuSchedule);
  }
}

//Default Values
export const PERMISSIONS = {
  Onboarding: {
    View: false,
    Edit: false,
    Add: false,
  },
  ExcelUpload: {
    View: false,
    Edit: false,
    Add: false,
  },
  WebsiteMonitor: {
    View: false,
    Edit: false,
    Add: false,
  },
  Services: {
    View: false,
    Edit: false,
    Add: false,
  },
  UserManagement: {
    View: false,
    Edit: false,
    Add: false,
  },
  Configurations: {
    View: false,
    Edit: false,
    Add: false,
    Templates: {
      WebCustomer: {
        View: false,
        Edit: false,
        Add: false,
      },
      MobileCustomer: {
        View: false,
        Edit: false,
        Add: false,
      },
      WebBusiness: {
        View: false,
        Edit: false,
        Add: false,
      },
      MobileBusiness: {
        View: false,
        Edit: false,
        Add: false,
      },
      WebAdminPortal: {
        View: false,
        Edit: false,
        Add: false,
      },
    },
    Configs: {
      Order: {
        View: false,
        Edit: false,
        Add: false,
      },
      Reservation: {
        View: false,
        Edit: false,
        Add: false,
      },
    },
    BrandTable: {
      View: false,
      Edit: false,
      Add: false,
    },
    RecipeAllergens: {
      View: false,
      Edit: false,
      Add: false,
    },
  },
  Settings: {
    View: false,
    Edit: false,
    Add: false,
  },
  Menu: {
    View: false,
    Edit: false,
    Add: false,
    Download: false,
    Upload: false,
    ManageAllergens: false,
  },
  Products: {
    View: false,
    Edit: false,
    Add: false,
  },
  Categories: {
    View: false,
    Edit: false,
    Add: false,
  },
  Brand: {
    View: false,
    Edit: false,
    Add: false,
    Details: {
      View: false,
      Edit: false,
      Add: false,
    },
    Merchants: {
      View: false,
      Edit: false,
      Add: false,
    },
  },
  Orders: {
    View: false,
    Edit: false,
    Add: false,
  },
  Campaigns: {
    View: false,
    Edit: false,
    Add: false,
    Promotions: {
      View: false,
      Edit: false,
      Add: false,
    },
    Discounts: {
      View: false,
      Edit: false,
      Add: false,
    },
    Referral: {
      View: false,
      Edit: false,
      Add: false,
    },
    Announcements: {
      View: false,
      Edit: false,
      Add: false,
    },
    Notifications: {
      View: false,
      Edit: false,
      Add: false,
    },
  },
  Rewards: {
    View: false,
    Edit: false,
    Add: false,
  },
  Customers: {
    View: false,
    Edit: false,
    Add: false,
    Download: false,
    AddPoint: false,
    DeductPoints: false,
    AddBalance: false,
    DeductBalacnce: false,
  },
  BlockedUsers: {
    View: false,
    Edit: false,
    Add: false,
  },
  AccountTypes: {
    View: false,
    Edit: false,
    Add: false,
  },
  AccountConfigs: {
    View: false,
    Edit: false,
    Add: false,
  },
  Keys: {
    View: false,
    Edit: false,
    Add: false,
    Map: {
      View: false,
      Edit: false,
      Add: false,
    },
    Firebase: {
      View: false,
      Edit: false,
      Add: false,
    },
  },
  FCM: {
    View: false,
    Edit: false,
    Add: false,
  },
  ImportData: {
    View: false,
    Edit: false,
    Add: false,
  },
  PrintSections: {
    View: false,
    Edit: false,
    Add: false,
    Category: {
      View: false,
      Edit: false,
      Add: false,
    },
    Recipe: {
      View: false,
      Edit: false,
      Add: false,
    },
    Products: {
      View: false,
      Edit: false,
      Add: false,
    },
  },
  BrandSections: {
    View: false,
    Edit: false,
    Add: false,
    Category: {
      View: false,
      Edit: false,
      Add: false,
    },
    Recipe: {
      View: false,
      Edit: false,
      Add: false,
    },
    Products: {
      View: false,
      Edit: false,
      Add: false,
    },
  },
  ReceiptTypes: {
    View: false,
    Edit: false,
    Add: false,
  },
  Reservations: {
    View: false,
    Edit: false,
    Add: false,
  },
  Events: {
    View: false,
    Edit: false,
    Add: false,
  },
  Transactions: {
    View: false,
    Edit: false,
    Add: false,
  },
  Accounts: {
    View: false,
    Edit: false,
    Add: false,
  },
  Payments: {
    View: false,
    Edit: false,
    Add: false,
  },
  DataRequests: {
    View: false,
    Edit: false,
    Add: false,
    DormantCustomers: {
      View: false,
      Edit: false,
      Add: false,
    },
    CustomerContacts: {
      View: false,
      Edit: false,
      Add: false,
    },
  },
  MenuSchedule: {
    View: false,
    Edit: false,
    Add: false,
  },
};
